import { get, set } from 'idb-keyval';

/**
 * v5 — Réglages de fidélité client
 *
 * Permet à l'admin d'activer/désactiver la demande de téléphone
 * sur l'écran "Vos informations" du kiosk.
 *
 * Si activé → un champ téléphone optionnel apparaît à côté du nom.
 * Si désactivé → comportement actuel inchangé (commande anonyme).
 */

export interface LoyaltySettings {
  /** Activer la demande de téléphone pour la fidélité */
  phonePromptEnabled: boolean;
  /** v5: Activer l'utilisation des points (en plus du cumul). Toggle LOCAL admin.
   * Reste soumis à la double validation : backend doit autoriser aussi (channel_allowed). */
  redeemEnabled: boolean;
}

const STORAGE_KEY = 'loyaltySettings';

export const DEFAULT_LOYALTY: LoyaltySettings = {
  // v5: désactivés par défaut. Le restaurant doit explicitement activer la fidélité.
  // Cela évite qu'un nouveau kiosk affiche le champ téléphone sans config voulue.
  phonePromptEnabled: false,
  redeemEnabled: false,
};

export async function getLoyaltySettings(): Promise<LoyaltySettings> {
  try {
    const stored = await get<LoyaltySettings>(STORAGE_KEY);
    if (stored && typeof stored === 'object') {
      return { ...DEFAULT_LOYALTY, ...stored };
    }
  } catch (e) {
    console.error('[Loyalty] load error', e);
  }
  return DEFAULT_LOYALTY;
}

export async function saveLoyaltySettings(s: LoyaltySettings): Promise<boolean> {
  try {
    await set(STORAGE_KEY, s);
    window.dispatchEvent(new CustomEvent('loyaltySettingsUpdated', { detail: s }));
    return true;
  } catch (e) {
    console.error('[Loyalty] save error', e);
    return false;
  }
}
